<nz-card [nzActions]="[actionClose, actionDelete]">
    <p> <strong> Sicuro di voler eliminare questo canale?</strong></p>
    <p>Verranno eliminati anche i video Live e On Demand legati a questo canale!</p>
    <p>Questa azione è permanente.</p>
</nz-card>
<ng-template #actionClose>
    <button type="button" nz-button nzSize="large" (click)="onClose()">Annulla</button>
</ng-template>
<ng-template #actionDelete>
    <button nz-button type="button" [nzSize]="'large'" class="home-button" [nzLoading]="loading" (click)="onElimina()">Elimina</button>
</ng-template>